// src/pages/Dashboard/Dashboard.jsx - UPDATED VERSION
import React, { useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import CompanyListDashboard from './CompanyListDashboard';
import AdminDashboard from '../AdminDashboard/AdminDashboard';

const Dashboard = () => {
  const { user, isSuperAdmin, isAdmin } = useAuth();
  const navigate = useNavigate();

  // Determine which dashboard to show
const showCompanyList    = (isSuperAdmin || user?.role === 'OFFICE_ADMIN') && !user?.companyId;
const showAdminDashboard = user?.companyId || isAdmin;

  if (showCompanyList) {
    // Super Admin without company assignment -> Show company list
    return <CompanyListDashboard />;
  } else if (showAdminDashboard) {
    // Admin with company OR Super Admin with company -> Show admin dashboard
    return <AdminDashboard />;
  } else {
    // Regular user -> Generic dashboard
    return (
      <div className="dashboard-container">
        <div className="welcome-section">
          <h2>Welcome to Haritpane Agro Dashboard</h2>
         
        </div>
      </div>
    );
  }
};

export default Dashboard;